<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden mt-3">
      <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Habsburkové českými králi</h2>
      <div class="my-1 flex items-center justify-center">
        <span>Pokud chcete raději video, najdete ho na následujícím odkazu</span>
        <a href="https://www.youtube.com/watch?v=vZfzWO-nu7M&list=PLnplwgXmL676ZF4XY6BrbKpRFABnZExbv&index=61" target="_blank">
          <svg class="ml-2 w-10 h-10 fill-current text-red-800 hover:text-red-700 cursor-pointer" viewBox="0 0 20 20">
            <path
              d="M11.603 9.833L9.357 8.785C9.161 8.694 9 8.796 9 9.013v1.974c0 .217.161.319.357.228l2.245-1.048c.197-.092.197-.242.001-.334zM10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6S15.302.4 10 .4zm0 13.5c-4.914 0-5-.443-5-3.9s.086-3.9 5-3.9 5 .443 5 3.9-.086 3.9-5 3.9z"
            /></svg
        ></a>
      </div>
      <div>
        <p>
          <strong>V roce 1526 zemřel český král Ludvík Jagellonský</strong>. Neměl žádné děti, a tak <strong>české země</strong> zůstaly <strong>bez panovníka</strong>. Šlechtici se radili, komu
          nabídnout českou královskou korunu. Za předchozích panovníků získali mnozí významná místa v úřadech. Mohli tak rozhodovat o důležitých záležitostech země. Pochopitelně jim záleželo na tom,
          aby nový panovník jejich úřady a výsady zachoval.
        </p>
        <p>
          Česká šlechta nakonec nabídla uvolněný trůn <strong>Habsburkům</strong> - bohatému rakouskému rodu. <strong>Nástupem Habsburků na trůn v roce 1526</strong> začíná v českých zemích období
          nazývané
        </p>
        <h3 class="my-2 text-orange-600 font-bold text-2xl text-center">Novověk</h3>
        <p>
          Habskurkové spojili pod svou vládou <strong>Rakousko, české země</strong> (byly složeny z Čech, Moravy a Slezska) a <strong>Uhry</strong> (dnešní Maďarsko).
          <strong>Vytvořili tak velkou říši. Vládli v ní</strong> ( a tedy i u nás) až <strong>do roku 1918</strong>.
        </p>
        <p>
          Výhodou velké říše bylo, že se mohla lépe bránit proti útokům nepřátel. Nová říše nedostala žádný oficiální název. Říkalo se jí např. <strong>habsburská říše</strong> nebo
          <strong>rakouská říše</strong>.
        </p>
        <p class="text-center font-bold text-2xl py-2">
          <span class="text-2xl">habsburská říše</span> = <span class="text-teal-800 font-bold text-2xl uppercase">Rakousko</span> +
          <span class="text-orange-500 font-bold text-2xl uppercase">české země</span> +
          <span class="text-green-500 font-bold text-2xl uppercase">Uhry</span>
        </p>
        <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Vzpoura proti Habsburkům</h2>
        <p>
          <strong>Habsburským panovníkům</strong> záleželo na tom, aby jejich velká říše byla silná a nerozpadla se. Proto v ní <strong>chtěli mít neomezenou moc</strong>. Začali tedy omezovat výhody
          a velký vliv šlechticů a měst. Habsburští panovníci zřídili ve Vídni nové úřady nadřazené úřadům českým. Tam se také odstěhovali se svým dvorem. O všech důležitých věcech rozhodovali
          úředníci ve Vídni.
        </p>
        <p>
          Jediný český král z rodu Habsburků Rudolf II. (vládl v 16. století) si za své sídlo zvolil místo Vídně Prahu.
        </p>
        <p>
          Čeští šlechtici postupně ztráceli právo zasahovat do státních záležitostí. To je pobouřilo. Na začátku 17. století (roku 1618) za vlády krále Matyáše začalo povstání proti vládě Habsburků.
        </p>
        <p>
          Skupina šlechticů se tehdy vydala za královskými úředníky na Pražský hrad. Vytýkali jim, že porušují výhody šlechty a měst. Došlo k hádce a rozhněvaní šlechtici vyhodili dva úředníky a
          písaře z oken do hradního příkopu. Ti dopadli na hromadu odpadků, takže se jim celkem nic nestalo. To byl začátek povstání proti Habsburkům.
        </p>
        <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Bitva na Bílé hoře</h2>
        <p>
          Rozpory mezi Habsburky a českou šlechtou vedly nakonec k bitvě. Armáda krále z rodu Habsburků Ferdinanda II. se střetla s vojskem českých šlechticů8. listopadu roku 1620 na Bílé hoře u
          Prahy. Bitva trval necelé dvě hodiny. Španě vyzbrojení a málo placení vojáci české šlechty se hned po prvním útoku králova vojska dali na útěk. Habsburské vojsko tak zvítězilo a mohlo bez
          dalšího boje vstoupit do Prahy.
        </p>
        <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Následky bitvy na Bílé hoře</h2>
        <p>
          Král Ferdinand II. dal roku 1621 pro výstrahu popravit v Praze na Staroměstském náměstí 27 vůdců povstání. Dalším vzbouřencům se podařilo uprchnout ze země.
        </p>
        <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Všichni musí být katolíky</h2>
        <p>
          Habsburkové byli katolíci. Proto se snažili obrátit všechny nekatolíky českého království na katolickou víru. Po bitvě na Bílé hoře povolil král pouze katolické náboženství. Nekatolíci měli
          dvě možnosti. Buď se nechat pokřtít, nebo odejít do zahraničí. Tehdy opustili zem tisíce vzdělaných lidí. Poddaní se vystěhovat nesměli, protože by ubylo pracovních sil. Neměli tedy jinou
          možnost než přestoupit na katolickou víru. Všechny obyvatele českých zemí se na katolické náboženství převést nepodařilo. Někteří tajně dál vyznávali svoji víru.
        </p>
        <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Jan Amos Komenský (28. března 1592 Uherský Brod - 15. listopadu 1670 Amsterdam )</h2>
        <p class="text-sm text-gray-700 text-center cursor-pointer hover:text-gray-900 font-bold">
          <a href="https://cs.wikipedia.org/wiki/Jan_Amos_Komensk%C3%BD" target="_blank">více informací na Wikipedii</a>
        </p>
        <p>
          Jedním z nekatolíků, kteří po bitvě na Bílé hoře museli opustit zemi, byl kněz a učitel Jan Amos Komenský. Má velkou zásluhu na změnách ve způsobu vyučování. Psal také učebnice pro děti.
        </p>
        <p>
          V této době se děti musely všechno učit nazpamět a při zkoušení odříkávat učivo přesně tak, jak bylo v učebnici. Komenský chtěl, aby se děti učily snadno a hodiny byly zábavné - taková
          "škola hrou". Probíranou látku vysvětloval tak, aby ji děti pochopily. Používal obrázky, modely a jiné názorné pomůcky. Komenský také navrhoval, aby do školy chodili nejen chlapci, ale také
          děvčata.
        </p>
        <p>
          Jan Amos Komenský vytvořil první obrázkovou učebnici nazvanou Svět v obrazech. Sloužila dětem ke studiu cizího jazyka (latiny). Byla vydána ve všech světových jazycích.
        </p>
        <p>
          Jednou z myšlenek Jana Amose Komenského bylo, aby na celém světě skončilo násilí a války, aby si lidé pomáhali a byli k sobě laskaví. Dějiny bohužel ukazují, že taková myšlenka je zatím
          nesplnitelná.
        </p>
        <div>
          <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Při výuce samé aplikoval Komenský tyto zásady:</h2>
          <ul class=" list-inside list-decimal">
            <li><strong>zásada názornosti</strong> – přímá žákova zkušenost</li>
            <li>
              <strong>zásada systematičnosti a soustavnosti</strong> – učivo by na sebe mělo navazovat, nejen v jednotlivých předmětech, ale i mezi nimi. Je třeba zajistit soustavný vzdělávací režim
            </li>
            <li><strong>zásada aktivnosti</strong> – žáci by měli své poznatky získávat vlastní zkušeností, využívat je v praxi</li>
            <li><strong>zásada trvalosti</strong> – je třeba soustavně učivo opakovat</li>
            <li><strong>zásada přiměřenosti</strong> – učitel by měl vycházet z věkových a individuálních schopností dětí</li>
          </ul>
          <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Děti dělil podle nadání:</h2>
          <ul class=" list-inside list-disc">
            <li>bystré, dělají radost</li>
            <li>bystré, líné</li>
            <li>bystré, vzpurné</li>
            <li>s nedostatkem bystré mysli</li>
            <li>s nedostatkem bystré mysli, líné</li>
            <li>s nedostatkem bystré mysli, vzpurné</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Habsburkove"
};
</script>

<style lang="scss" scoped></style>
